export async function teacherRequest(url, body = {}, options = {}) {
  const response = await fetch(url, {
    method: 'POST',
    headers: body instanceof FormData ? undefined : { 'Content-Type': 'application/json' },
    body: body instanceof FormData ? body : JSON.stringify(body),
    signal: options.signal,
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || !payload.status) throw new Error(payload.message || 'Unable to complete the teacher request.');
  return payload;
}

export async function teacherDocument(url, id, documentType) {
  const response = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id, document_type: documentType }) });
  if (!response.ok) { const payload = await response.json().catch(() => ({})); throw new Error(payload.message || 'Unable to open document.'); }
  const blob = await response.blob();
  return { url: URL.createObjectURL(blob), mimeType: blob.type || response.headers.get('Content-Type') || 'application/octet-stream' };
}
